import logo from './logo.svg';
import MainComponent from './components/MainComponent/MainComponent';
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
const App = () => {
  return (
    <PrimeReactProvider>
        <MainComponent />
    </PrimeReactProvider>
  );
}

export default App;
